import React from 'react';

import './Tooltip.scss';

export default class Tooltip extends React.Component {
    render() {
        const { children, text } = this.props;

        return (
            <span className="tooltip">
                {children}
                <span className="tooltip-text-wrapper">
                    <span className="tooltip-text">{text}</span>
                </span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tooltip/Tooltip.js